import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../Header";
import Footer from "../Footer";


const InsProject4 = () => {
  const navigate = useNavigate();

  const onGroupClick = useCallback(() => {
    navigate("/");
  }, [navigate]);

  const onResearchAreaTextClick = useCallback(() => {
    navigate("/researcharea");
  }, [navigate]);

  const onProjectsTextClick = useCallback(() => {
    navigate("/desktop-3");
  }, [navigate]);

  const onAboutUsTextClick = useCallback(() => {
    navigate("/about-us");
  }, [navigate]);

  const onAboutUsText2Click = useCallback(() => {
    navigate("/researcharea");
  }, [navigate]);

  const onCareersTextClick = useCallback(() => {
    navigate("/desktop-3");
  }, [navigate]);

  return (
   
      <div className="relative bg-gray md:w-full w-[739px] p-0 mx-full">
        <Header />
        <div className="bg-gray py-16 mx-10 font-poppins">
          <div className="container mx-auto">
            <div className="px-4 md:px-0">
              <div className="absolute w-full top-[95px] right-[0px] left-[0px] bg-gradient-to-b from-black [background:linear-gradient(180deg,_#09011a,_rgba(105,_63,_196,_0.57)_43%,_rgba(163,_134,_223,_0)_91%)]  h-[466px] overflow-hidden text-4xl md:text-5xl lg:text-6xl">
                <div className="absolute top-[111px] left-[910px] rounded-381xl [background:radial-gradient(50%50%_at_50%_50%,_rgba(120,_100,_161,_0.53)_26.5%,#1c054e_39.88%,_rgba(223,_208,_255,_0))] w-[827px] h-[826px] overflow-hidden hidden" />
                <div className="absolute top-[181px] left-[50%] transform -translate-x-1/2 rounded-full bg-gray-400 w-[686px] h-[686px] overflow-hidden" />
                <img
                  className="absolute top-[0px] left-[50%] transform -translate-x-1/2 w-full md:max-w-[1160px] md:h-[375.6px] md:w-auto h-auto"
                  alt=""
                  src="/artboard-44x-1@2x.png"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="container mx-auto pt-[300px] font-poppins ">
          <b className="text-29xl md:text-29xl m-5 font-bold text-blue flex content-center items-center">Hospitals as Stakeholders:       Exploring the Role and Impact of Healthcare Institutions in Insurance
          </b>
          <h3 className="text-13xl text-blue m-5" >Synopsis:</h3>
          <p className="mb-10 m-5 leading-relaxed text-cold-grey-white text-justify font-poppins text-13xl md:text-xl md:mb-5 lg:mb-5 xl:mb-5 lg:text-base transform scale-120">
            The research project titled "Hospitals as Stakeholders: Exploring the Role and Impact of Healthcare Institutions in Insurance" delves into the intricate dynamics between hospitals and the insurance ecosystem. With a primary focus on hospitals as key stakeholders, the study aims to comprehensively examine their roles and the subsequent impact on healthcare financing. Through rigorous investigation, the research seeks to unravel collaborative models existing between hospitals and insurers, critically assess their influence on patient outcomes, and explore the broader implications for insurance coverage within the healthcare domain.

          </p>


          <h2 className="text-29xl lg:text-17xl text-blue m-5" >AI Tool Name:HealthInsight AI
          </h2>
          <h3 className="text-17xl text-blue m-5" >Objective:</h3>

          <p className="mb-5 m-5 leading-relaxed text-cold-grey-white text-justify font-poppins text-13xl md:text-xl  lg:text-base transform scale-120">
            The AI tool, "HealthInsight AI," is designed to analyze and optimize
            the collaboration between hospitals and insurance providers. Its
            primary scope is to enhance the understanding of collaborative
            models, assess their impact on patient outcomes, and provide
            insights into effective partnerships. The tool employs advanced
            analytics and machine learning algorithms to process data from
            hospitals and insurers, facilitating a comprehensive analysis of
            their roles in the insurance ecosystem.

          </p>

          <h3 className="text-29xl lg:text-17xl text-blue m-5" >Key Features:</h3>
          <ul className="mb-5 m-5 leading-relaxed text-cold-grey-white text-justify font-poppins text-13xl md:text-xl  lg:text-base transform scale-120">
            <li className="p-1 "> Collaborative Model Analysis: Utilizes AI to analyze existing
              collaborative models, identifying patterns and successful
              strategies.
            </li>
            <li className="p-1">  Patient Outcome Assessment: Incorporates machine learning to
              assess the influence of collaborative models on patient outcomes,
              including treatment efficacy and cost-effectiveness.

            </li>
            <li className="p-1"> Policy Framework Evaluation: Performs a detailed analysis of
              regulatory policies shaping hospital-insurer partnerships to
              ensure compliance and ethical considerations.

            </li>
          </ul>

          <h3 className="text-29xl lg:text-17xl  text-blue m-5" >Target Audience:</h3>
          <ul className="mb-5 m-5 leading-relaxed text-cold-grey-white text-justify font-poppins text-13xl md:text-xl  lg:text-base transform scale-120">
            <li className="p-1">  The target audience includes healthcare professionals, insurance
              providers, policymakers, and researchers seeking insights into
              optimizing collaborative efforts between hospitals and insurers.


            </li>
          </ul>

          <h3 className="text-29xl lg:text-17xl  text-blue m-5" >Project Impact:</h3>
          <ul className="mb-5 m-5 leading-relaxed text-cold-grey-white text-justify font-poppins text-13xl md:text-xl  lg:text-base transform scale-120 ">

            <li className="p-1"> The tool aims to provide actionable insights into fostering
              effective partnerships, potentially improving healthcare
              financing, patient outcomes, and the efficiency of insurance
              coverage. By enhancing understanding and collaboration,
              "HealthInsight AI" can contribute to more informed
              decision-making in the healthcare and insurance sectors.

            </li>




          </ul>
          <h3 className="text-29xl lg:text-17xl  text-blue m-5" >Conclusion:</h3>
          <p className="mb-[200px] m-5 leading-relaxed text-cold-grey-white text-justify font-poppins text-13xl md:text-xl  lg:text-base transform scale-120">
            The development of "HealthInsight AI" is poised to bring
            transparency and efficiency to the intricate relationships between
            hospitals and insurance providers. Through its analytical
            capabilities, the tool has the potential to catalyze positive
            changes in collaborative models, ultimately benefiting both
            healthcare institutions and insurance providers while improving
            the overall quality of patient care
          </p>
        </div>
        <Footer />
      </div>
    );
  };


  
export default InsProject4;